import { withErrorBoundary, Spinner, NoResults } from 'shared'
import { Backend } from 'base'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileWord, faFilePdf, faFileImage, faFile, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { InfoNavbar } from 'layout'
import { useEffect, useState } from 'react'

const Documents = () => {
  // State
  const [state, setState] = useState({ data: null })

  // Consts

  // Hooks
  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    let data = App.state.getObject('documents')
    if (!data) {
      data = await Backend.get('/documents')
      App.state.setObject({ documents: data })
    }
    setState({ data })
  }

  const renderFileTypeIcon = (fileType) => {
    let icon = { image: faFileImage, word: faFileWord, pdf: faFilePdf, file: faFile, text: faFileAlt }[fileType]
    return <FontAwesomeIcon icon={icon} />
  }

  // Consts
  let { data } = state
  return (
    <div className="documents-page">
      <InfoNavbar />
      {data == null ?
        <Spinner />
        :
        <React.Fragment>
          <div className="documents-page-preambule" dangerouslySetInnerHTML={{__html: data.header_html}}></div>
          <div className="documents-page-body">
            {data.groups.map(group =>
              <div className="document-group" key={group.id}>
                <h3>{group.name}</h3>
                <ul className="document-links">
                  {group.documents.map(document =>
                    <li key={document.id}>
                      <a href={document.url} target="_blank">
                        {renderFileTypeIcon(document.type)}{' '}
                        {document.name}
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </React.Fragment>
      }
    </div>
  )
}

export default withErrorBoundary(Documents)
